// extracted by mini-css-extract-plugin
export default {"accept-drop":"_1GoIW","acceptDrop":"_1GoIW","reject-drop":"_3MmMj","rejectDrop":"_3MmMj"};